import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

const ProtectedRoute = ({ element }) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return (
      <Routes>
        <Route exact path="/" element={<Navigate to="/portal" />} />
      </Routes>
    );
  }
  return element;
};

export default ProtectedRoute;